import React, { useCallback } from 'react';
import { Card, Form } from 'react-bootstrap';

import { useFormikContext } from 'formik';

import { updateQueryStringOnFieldChange } from '@components/Filters/Filters';
import { useThrottle } from '@features/useThrottle';
import { areaApi, countryApi } from '@reducers/geo';
import { skipToken } from '@reduxjs/toolkit/query';

export const MyNumbersFilter = ({ searchParams, setSearchParams }) => {
  const { handleChange, handleBlur, values } = useFormikContext();
  const countries = countryApi.useGetForDidsForSelectQuery();
  const areas = areaApi.useGetForSelectQuery(
    values.country ? { id: values.country } : skipToken
  );
  const throttle = useThrottle((event) => {
    updateQueryStringOnFieldChange(event, { searchParams, setSearchParams });
  }, 500);

  const throttledChangeHandler = useCallback(
    (event) => {
      handleChange(event);
      throttle(event);
    },
    [throttle]
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Search form</Card.Header>
      <Card.Body>
        <Form.Group className="mb-3" controlId="formGroupCountry">
          <Form.Label>Country</Form.Label>
          <Form.Select
            name="country"
            size="sm"
            value={values.country}
            onChange={(e) => {
              handleChange(e);
              updateQueryStringOnFieldChange(e, {
                clearFields: ['area'],
                searchParams,
                setSearchParams,
              });
            }}
            onBlur={handleBlur}
          >
            <option value="">Select country</option>
            {!countries.isLoading &&
            !countries.isError &&
            countries.data.length > 0 ? (
              <>
                {countries.data.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </>
            ) : null}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupArea">
          <Form.Label>Area</Form.Label>
          <Form.Select
            name="area"
            size="sm"
            value={values.area}
            onChange={(e) => {
              handleChange(e);
              updateQueryStringOnFieldChange(e, {
                searchParams,
                setSearchParams,
              });
            }}
            onBlur={handleBlur}
            disabled={!values.country}
          >
            <option value="">
              {values.country ? 'Select area' : 'Select country to see areas'}
            </option>
            {!areas.isUninitialized &&
            !areas.isLoading &&
            !areas.isError &&
            areas.data.length > 0 ? (
              <>
                {areas.data.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </>
            ) : null}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupDid">
          <Form.Label>DID Number</Form.Label>
          <Form.Control
            type="input"
            name="did"
            size="sm"
            value={values.did}
            onChange={throttledChangeHandler}
            onBlur={handleBlur}
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};
